module.exports = __webpack_public_path__ + "static/media/33-2.f1efdc98.mp3";